<div id="UptimeChart">
  <app-loader [isLoading]="isLoading"></app-loader>
  @if (noData) {
    <div class="noData">No Data</div>
  }
  @if (!noData && !isLoading) {
    <div>
      <app-highcharts-generic
        [chartheight]="'20rem'"
        [options]="pie_options"
        [series]="uptime_series"
      ></app-highcharts-generic>
    </div>
  }
</div>
